import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext, StateToken } from '@ngxs/store';
import { AddUrlVisited } from '@stores/visited-url/visited-url.action';

const VisitedUrlToken = new StateToken<string[]>('visitedUrl');

@State<string[]>({
  name: VisitedUrlToken,
  defaults: [],
})
@Injectable()
export class VisitedUrlState {
  static isUrlVisited(url: string): (urls: string[]) => boolean {
    return createSelector([VisitedUrlState], (urls: string[]) => {
      return urls.includes(url);
    });
  }

  @Action(AddUrlVisited)
  addUrlVisited(ctx: StateContext<string[]>, visitedUrl: AddUrlVisited): void {
    const state = ctx.getState();
    if (!state?.includes(visitedUrl.url)) {
      ctx.setState([...state, visitedUrl.url]);
    }
  }
}
